import { useState } from 'react';
import { Button, ModalContent } from 'components';
import { DiscountInput } from '../discount-input';

interface Props {
  handleClose: () => void;
  handleConfirm: (value: string) => void;
}

export function SeasonDiscountsModal({ handleClose, handleConfirm }: Props) {
  const [value, setValue] = useState('');

  return (
    <ModalContent handleClose={handleClose}>
      <div className="flex max-w-96 flex-col gap-4 text-neutral-500">
        <p className="font-bold">Insira o valor desejado para 252 Verão</p>

        <div className="flex gap-4">
          <DiscountInput
            autoFocus
            autoComplete="off"
            name="foo"
            value={value}
            onChange={(e) => setValue(e.target.value)}
          />

          <p className="text-xs">
            Este desconto se aplicará a todas coleções desta estação.
          </p>
        </div>

        <div className="flex flex-wrap-reverse gap-x-4 gap-y-2">
          <Button
            variant="secondary"
            full
            onClick={handleClose}
            className="flex-1"
          >
            Voltar
          </Button>

          <Button
            full
            className="flex-1"
            onClick={() => {
              handleConfirm(value);
              handleClose();
            }}
          >
            Aplicar desconto
          </Button>
        </div>
      </div>
    </ModalContent>
  );
}
